import React, { useState } from "react";
import { RCCAlert, RCCGrid, RCCHookToast, RCCServicesApi } from "react-common-components";
import AccordionList from "src/components/AccordionList";
import Loader from "src/components/Loader";
import { useTranslation } from "src/context/Translations/context";
import { IPhases } from "src/pages/Projects/Project/Components/Phases/interface";
import { standardErrorMessages } from "src/utils/errors";
import { IListProject, PhaseAgile, ProjectModel } from "../../interface";
import ListPhase from "../../listPhase";
import ProjectItem from "./item";

const ListProjects: React.FC<IListProject> = ({
	project,
	colorSituation,
	filterList,
	options,
	onCallbackProgram,
	onCallbackChangeProject,
	openModalAction,
	openModalChangeSprint,
	openModalDetails,
	openModalReleaseActions,
	openModalGantt
}) => {

	const { translate } = useTranslation();
	const { addToast } = RCCHookToast();
	const [appliedExpand, setAppliedExpand] = useState(false);
	const [loading, setLoading] = useState(false);
	const [errorLoading, setErrorLoading] = useState(false);


	const requestQuery = async (projectId: number) => {
		try{
			setLoading(true);
			setErrorLoading(false);

			const {data} = await RCCServicesApi.getRequest({
				method: "ProjectPhase/List",
				urlParameters: {
					projectId
				}
			});

			if(onCallbackChangeProject){
				onCallbackChangeProject({
					...project,
					prtba003: data
				});
			}
			

			setAppliedExpand(true);
			setLoading(false);
	
		}catch(err){
			setErrorLoading(true);
			standardErrorMessages(err, translate("Erro ao carregar os agrupadores"), addToast);
			setLoading(false);
		}
	};

	const handleClickGroupers = async (_e: any, expanded: boolean, projectId: number) => {
		if(!expanded || appliedExpand)
			return;
		requestQuery(projectId);
	};

	const getTypePhaseAgile = (order: number) => {
		if(project.pra002Modelo === ProjectModel.AGILE){
			if(order === 1){
				return PhaseAgile.BACKLOG;
			}
			return PhaseAgile.SPRINT;
		}
		return undefined;
	};	

	return (
		<>
			{
				filterList && filterList !== String(project.situation) ? "" :
					<RCCGrid className="accordion-project">
						<AccordionList 
							showExpandIcon={false}
							onChange={(e, expanded) => {e.stopPropagation(); handleClickGroupers(e, expanded, project.pra002Id);}}
							header={
								<>
									<div
										className="project-sidebar-situation" 
										style={{ position: "absolute", top: 0, left: 0, width: "4px", height: "100%", background: `var(--${colorSituation})`}}
									/>
									<ProjectItem 
										showHeader={false}
										imageOnly={false}
										data={[project]}
										options={options}
									/>
								</>
							}
							styleInline={{ header: "padding-right: 0 !important; padding-left: 8px;" }}
						>
							<>
								{
									loading ? (
										<Loader />
									) : (
										<>
											{errorLoading ? (
												<RCCAlert 
													title={translate("Atenção")}
													description={translate("Erro ao tentar encontrar resultados para esta pesquisa")}
												/>
											): (
												<>
													{project.prtba003 === undefined || project.prtba003.length === 0 ? (
														<RCCGrid 
															container 
															styleInline="margin: 10px"
														>
															<RCCAlert 
																title={translate("Atenção")}
																description={translate("Nenhuma fase encontrada")}
															/>
														</RCCGrid>
													): (
														<RCCGrid container item xs={12}>
															{project.prtba003?.map((phase: IPhases) => (
																<RCCGrid 
																	container 
																	item 
																	xs={12} 
																	key={`accordion-phase-${phase.pra003Id}`}
																	className="accordion-phase" 
																>
																	<ListPhase
																		project={project}
																		phase={{
																			...phase,
																			permission: project.permission
																		}  as IPhases }
																		phaseAgile={getTypePhaseAgile(phase.pra003Ordem)}
																		onCallbackProgram={onCallbackProgram}
																		requestQuery={requestQuery}
																		onCallbackChangeProject={onCallbackChangeProject}
																		openModalAction={openModalAction}
																		openModalChangeSprint={openModalChangeSprint}
																		openModalDetails={openModalDetails}
																		openModalReleaseActions={openModalReleaseActions}
																		openModalGantt={openModalGantt}
																	/>
																</RCCGrid>
															))
															}						
														</RCCGrid>
													)}
												</>
											)}
										</>
									)
								}
							</>
						</AccordionList>
					</RCCGrid>
			}
		</>
	);
};

export default ListProjects;
